import * as RollingDateOptionValues from './RollingDateOptionValues';
export const TODAY = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.TODAY',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.TODAY',
  value: RollingDateOptionValues.TODAY
};
export const YESTERDAY = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.YESTERDAY',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.YESTERDAY',
  value: RollingDateOptionValues.YESTERDAY
};
export const TOMORROW = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.TOMORROW',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.TOMORROW',
  value: RollingDateOptionValues.TOMORROW
};
export const THIS_WEEK = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_WEEK',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_WEEK',
  value: RollingDateOptionValues.THIS_WEEK
};
export const THIS_WEEK_SO_FAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_WEEK_SO_FAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_WEEK_SO_FAR',
  value: RollingDateOptionValues.THIS_WEEK_SO_FAR
};
export const LAST_WEEK = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_WEEK',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_WEEK',
  value: RollingDateOptionValues.LAST_WEEK
};
export const NEXT_WEEK = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.NEXT_WEEK',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.NEXT_WEEK',
  value: RollingDateOptionValues.NEXT_WEEK
};
export const THIS_MONTH = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_MONTH',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_MONTH',
  value: RollingDateOptionValues.THIS_MONTH
};
export const THIS_MONTH_SO_FAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_MONTH_SO_FAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_MONTH_SO_FAR',
  value: RollingDateOptionValues.THIS_MONTH_SO_FAR
};
export const LAST_MONTH = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_MONTH',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_MONTH',
  value: RollingDateOptionValues.LAST_MONTH
};
export const NEXT_MONTH = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.NEXT_MONTH',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.NEXT_MONTH',
  value: RollingDateOptionValues.NEXT_MONTH
};
export const THIS_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_QUARTER',
  value: RollingDateOptionValues.THIS_QUARTER
};
export const THIS_FISCAL_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_FISCAL_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_FISCAL_QUARTER',
  value: RollingDateOptionValues.THIS_FISCAL_QUARTER
};
export const THIS_QUARTER_SO_FAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_QUARTER_SO_FAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_QUARTER_SO_FAR',
  value: RollingDateOptionValues.THIS_QUARTER_SO_FAR
};
export const THIS_FISCAL_QUARTER_SO_FAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_FISCAL_QUARTER_SO_FAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_FISCAL_QUARTER_SO_FAR',
  value: RollingDateOptionValues.THIS_FISCAL_QUARTER_SO_FAR
};
export const LAST_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_QUARTER',
  value: RollingDateOptionValues.LAST_QUARTER
};
export const LAST_FISCAL_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_FISCAL_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_FISCAL_QUARTER',
  value: RollingDateOptionValues.LAST_FISCAL_QUARTER
};
export const NEXT_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.NEXT_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.NEXT_QUARTER',
  value: RollingDateOptionValues.NEXT_QUARTER
};
export const NEXT_FISCAL_QUARTER = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.NEXT_FISCAL_QUARTER',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.NEXT_FISCAL_QUARTER',
  value: RollingDateOptionValues.NEXT_FISCAL_QUARTER
};
export const THIS_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_YEAR',
  value: RollingDateOptionValues.THIS_YEAR
};
export const THIS_FISCAL_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_FISCAL_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_FISCAL_YEAR',
  value: RollingDateOptionValues.THIS_FISCAL_YEAR
};
export const THIS_YEAR_SO_FAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_YEAR_SO_FAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_YEAR_SO_FAR',
  value: RollingDateOptionValues.THIS_YEAR_SO_FAR
};
export const THIS_FISCAL_YEAR_SO_FAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.THIS_FISCAL_YEAR_SO_FAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.THIS_FISCAL_YEAR_SO_FAR',
  value: RollingDateOptionValues.THIS_FISCAL_YEAR_SO_FAR
};
export const LAST_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_YEAR',
  value: RollingDateOptionValues.LAST_YEAR
};
export const LAST_FISCAL_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_FISCAL_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_FISCAL_YEAR',
  value: RollingDateOptionValues.LAST_FISCAL_YEAR
};
export const NEXT_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.NEXT_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.NEXT_YEAR',
  value: RollingDateOptionValues.NEXT_YEAR
};
export const NEXT_FISCAL_YEAR = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.NEXT_FISCAL_YEAR',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.NEXT_FISCAL_YEAR',
  value: RollingDateOptionValues.NEXT_FISCAL_YEAR
};
export const LAST_7_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_7_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_7_DAYS',
  value: RollingDateOptionValues.LAST_7_DAYS
};
export const LAST_14_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_14_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_14_DAYS',
  value: RollingDateOptionValues.LAST_14_DAYS
};
export const LAST_30_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_30_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_30_DAYS',
  value: RollingDateOptionValues.LAST_30_DAYS
};
export const LAST_60_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_60_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_60_DAYS',
  value: RollingDateOptionValues.LAST_60_DAYS
};
export const LAST_90_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_90_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_90_DAYS',
  value: RollingDateOptionValues.LAST_90_DAYS
};
export const LAST_180_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_180_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_180_DAYS',
  value: RollingDateOptionValues.LAST_180_DAYS
};
export const LAST_365_DAYS = {
  helpToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.help.LAST_365_DAYS',
  textToken: 'customerDataFiltersUI.customerDataFilters.RollingDates.options.text.LAST_365_DAYS',
  value: RollingDateOptionValues.LAST_365_DAYS
};